// @flow
import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import {
  Divider,
  FormControlLabel,
  IconButton,
  Typography,
} from '@material-ui/core';
import {ArrowBack} from '@material-ui/icons';

import {makeStyles} from '@material-ui/styles';
import {colors} from '../../../../../assets/styles/colors';
import {useBindedActions} from '../../../../../utils/globalStore';
import {actions as LegalActions} from '../../duck';
import IosSwitch from '../../../../../elements/IosSwitch/IosSwitch';
import PremiumFeatureBadge from '../../../../../elements/PremiumFeatureBadge/PremiumFeatureBadge';

type Props = {
  title: string,
  description: string,
  enabledKeyName: string,
  enabled?: boolean,
  disabled?: boolean,
  onChangeEnabled?: (enabled: boolean) => void,
};

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'flex-start',
    marginBottom: theme.spacing(0.5),
  },
  legalName: {
    fontSize: 16,
    color: colors.grey900,
    fontWeight: 600,
  },
  legalDesc: {
    fontSize: 14,
    fontWeight: 400,
    color: colors.grey900,
  },
  divider: {
    backgroundColor: colors.grey200,
    margin: theme.spacing(1, 0, 2, 0),
    width: '100%',
  },
  iconButton: {
    marginRight: theme.spacing(1),
  },
  rightContent: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  text: {
    fontWeight: 500,
    fontSize: 14,
    color: colors.grey900,
  },
}));

const actions = {
  saveStoreLegalSetting: LegalActions.saveStoreLegalSetting,
};
export default function HeaderTitle(props: Props) {
  const {
    title,
    description,
    enabledKeyName,
    enabled,
    disabled,
    onChangeEnabled,
  } = props;
  const classes = useStyles();

  const {saveStoreLegalSetting} = useBindedActions(actions);

  const handleEnableConfig = e => {
    if (onChangeEnabled) {
      onChangeEnabled(e.target.checked);
      return;
    }

    if (e && e.target) {
      saveStoreLegalSetting({
        legalSetting: {
          [enabledKeyName]: e.target.checked,
        },
      });
    }
  };

  return (
    <>
      <section className={classes.root}>
        <IconButton
          className={classes.iconButton}
          variant="contained"
          size="small"
          component={Link}
          to="/my-store/pages"
        >
          <ArrowBack />
        </IconButton>
        <div className={classes.rightContent}>
          <div className={classes.header}>
            <Typography className={classes.legalName} gutterBottom variant="h5">
              {title} {disabled && <PremiumFeatureBadge />}
            </Typography>
            <FormControlLabel
              control={
                <IosSwitch
                  defaultChecked={enabled}
                  checked={enabled}
                  name="enabled"
                  onChange={handleEnableConfig}
                  disabled={disabled}
                />
              }
              labelPlacement="start"
              label={
                <Typography className={classes.text}>
                  {enabled ? 'Activado' : 'Desactivado'}
                </Typography>
              }
            />
          </div>
          <Typography
            className={classes.legalDesc}
            gutterBottom
            variant="subtitle1"
          >
            {description}
          </Typography>
        </div>
      </section>
      <Divider className={classes.divider} />
    </>
  );
}

HeaderTitle.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};
